import React from 'react'
import movyx  from "../assets/MovyxSafe.png"
import "../styles/footer.css"

export const Footer = () => {
    return (
        <div className='footer-container'>
            <p className='description'>
                © 2025 Movyx Tecnologia SA. Todos os direitos reservados.
            </p>
            <img className='logo' src={movyx} alt="movyx-logo" />
        </div>
    )
}
